import http from "@/plugins/http";

export const state = {
  services: [],
  ipAddress: [],
};

export const getters = {
  services: state => {
    return state.services;
  },
  ipAddress: state => {
    return state.ipAddress;
  }
};

export const mutations = {
  SET_SERVICES(state, data) {
    state.services = data;
  },
  SET_ipAddress(state, data) {
    state.ipAddress = data;
  },
};

export const actions = {
  async select({ rootState, state, dispatch }, payload) {
    let data = null;
    let param = {};
    if (payload.val) {
      data = state.services.data.data.filter(
        x => x.radiusServiceId === parseInt(payload.val)
      );
      dispatch("service/setAvailableService", data[0], { root: true });

      switch (payload.path) {
        case "/service-details":
          dispatch("service/getService", {}, { root: true });
          dispatch("service/getStatus", {}, { root: true });
          param = {
            id: rootState.service.available.radiusServiceId,
            startDateTime: rootState.usageReport.start,
            endDateTime: rootState.usageReport.end
          };
          data = await http.post(`visp/ServiceUsages/${param.id}`);
          if (data.data !== "") {
            dispatch("usageReport/setUsage", data.data.data, {
              root: true
            });
          } else {
            dispatch("usageReport/setUsage", [], {
              root: true
            });
          }
          break;

        case "/auth-logs":
          dispatch("logs/getAuthLogs", {}, { root: true });
          break;
        case "/audit-logs":
          dispatch("logs/getAuditLogs", {}, { root: true });
          break;
      }
    }
  }
};
